var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3632 10.4388L16.4392 10.0948C17.4482 9.77281 18.5262 10.2938 18.9582 11.3118L19.8182 13.3398C20.1922 14.2228 19.9842 15.2618 19.3042 15.9078L17.4092 17.7058C17.5262 18.7818 17.8882 19.8408 18.4942 20.8828C19.0697 21.8909 19.8416 22.7734 20.7642 23.4778L23.0402 22.7178C23.9022 22.4308 24.8422 22.7618 25.3702 23.5388L26.6032 25.3488C27.2182 26.2528 27.1072 27.4988 26.3442 28.2648L25.5272 29.0858C24.7132 29.9028 23.5502 30.1998 22.4752 29.8638C19.9352 29.0718 17.6022 26.7208 15.4722 22.8108C13.3392 18.8948 12.5862 15.5708 13.2142 12.8428C13.4782 11.6948 14.2952 10.7798 15.3632 10.4388Z",
    fill: "#348287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.c510b98f87e61cd1ebe318fdb1ca8e12.svg";
export { ForwardRef as ReactComponent };